import LArtwork from "@components/LArtwork";
import LBox from "@components/LBox";
import LPressable from "@components/LPressable";
import LText from "@components/LText";
import { fonts } from "@theme";
import type { InboxItem } from "./InboxDetailSheet/types";
import { getInboxItemSummary } from "./inboxPresentation";

export const InboxItemRow = ({
  item,
  onPress,
}: {
  item: InboxItem;
  onPress: () => void;
}) => {
  const summary = getInboxItemSummary(item);

  return (
    <LPressable
      accessibilityHint="Opens notification details"
      accessibilityLabel={`${item.isRead ? "" : "Unread: "}${item.title}. ${summary}`}
      accessibilityRole="button"
      fadeEnabled
      onPress={onPress}
      sentryEventName="inbox_item_press"
    >
      <LBox
        alignItems="center"
        backgroundColor={item.isRead ? "transparent" : "whiteTranslucent10"}
        borderRadius="m-l"
        flexDirection="row"
        gap="s3"
        px="s2"
        py="s2"
      >
        <LArtwork
          borderRadius="m-l"
          size={56}
          url={item.imageUrl || item.image}
        />

        <LBox flex={1} gap="s1">
          <LText
            fontFamily={item.isRead ? fonts.medium : fonts.semiBold}
            numberOfLines={1}
            variant="Body/B2/Medium"
          >
            {item.title}
          </LText>
          <LText
            color={item.isRead ? "textGrey" : "subGrey"}
            numberOfLines={2}
            variant="Caption/C1/Regular"
          >
            {summary}
          </LText>
        </LBox>

        {!item.isRead ? (
          <LBox
            accessibilityLabel="Unread"
            backgroundColor="unreadNotification"
            borderRadius="max"
            height={8}
            testID="inbox-unread-indicator"
            width={8}
          />
        ) : null}
      </LBox>
    </LPressable>
  );
};
